import React from 'react';
import './NeedsAnalysisForm.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import TitleSession from "./TitleSession";
import Description from "./Description";

const NeedsAnalysisForm = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className="print__need">
              <HeaderPrint
                englishTitle={"Needs analysis form"}
                persianTitle={"فرم تحلیل نیازها"}
                color={"#B70000"}
              />
              <div className="print__need__text__box">
                <div className="print__need__text iransans-b">
                  <div className="print__subsystems__name">
                    <span>نام شرکت/آقای/ خانم</span>
                    <span>:</span>
                    <span>{item.interviewName}</span>
                  </div>
                  <div className="print__subsystems__phone">
                    <span>عنوان نیاز</span>
                    <span>:</span>
                    <span>{item.title}</span>
                  </div>
                </div>
                <div className="print__need__text iransans-b">
                  <div>
                    <span>شماره تماس</span>
                    <span>:</span>
                    <span>{item.interviewMobile}</span>
                  </div>
                  <div>
                    <span>کاربـر</span>
                    <span>:</span>
                    <span>{item.user}</span>
                  </div>
                </div>
                <div className="print__need__text iransans-b">
                  <div className="print__subsystems__phone">
                    <span>تاریخ</span>
                    <span>:</span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </div>
              <div className="print__need__title">
                <h5 className="iransans-b">عنوان بخش ها</h5>
                <TitleSession items={item}/>
              </div>
              <Description items={item}/>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default NeedsAnalysisForm;